import React from "react";

// Tailwind version of a row (flex container)
const BsRow = ({ className = "", style, children }) => (
  <div className={["", className].join(" ")} style={style}>
    {children}
  </div>
);

export default BsRow;
